export const ru = {
    'clicks-forecast': 'Прогноз кликов',
    'cost-forecast': 'Прогноз расхода, {currency}',
    name: 'Площадка'
};
